import { Slider, styled } from "@mui/material";

import React from "react";

type ISliderComponentProps = {
  value: number;
  handleRecommendationChange: (event: Event, newValue: number | number[]) => void;
}

const StyledSlider = styled(Slider)(({ theme })=>({
  "&.MuiSlider-root": {
    height: "8px",
  },
}));

const SliderComponent = (props: ISliderComponentProps) => {
  const { value, handleRecommendationChange } = props;

  return (
    <div className="!w-full">
      <StyledSlider
        aria-label="recommendUs"
        defaultValue={10}
        value={value}
        onChange={handleRecommendationChange}
        valueLabelDisplay="auto"
        step={1}
        min={1}
        max={10}
        size="medium"
      />
    </div>
  );
};

export default SliderComponent;
